import styled from 'vue-styled-components';

import { FLEX_COLUMN_DIV } from '@/styles/common.styled.component';

export const Wrapper = styled(FLEX_COLUMN_DIV)`
    flex: 1;
    cursor: default;
`;
